import { render, staticRenderFns } from "./areaRecordingYears.vue?vue&type=template&id=f3883cc8&scoped=true&"
import script from "./areaRecordingYears.vue?vue&type=script&lang=js&"
export * from "./areaRecordingYears.vue?vue&type=script&lang=js&"
import style0 from "./areaRecordingYears.vue?vue&type=style&index=0&id=f3883cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3883cc8",
  null
  
)

export default component.exports